import { cwslapi } from "../index";



// 获得个人仓库列表 —— 仓库管理
export const getItemListApi = (data) => {
  return cwslapi({
    url: "/store/getItemList",
    method: "post",
    data
  });
};



// 获得个人仓库单个道具信息 —— 仓库管理
export const getItemByIdApi = (data) => {
  return cwslapi({
    url: "/store/getItemById",
    method: "post",
    data
  });
};


// 划分操作 —— 仓库管理
export const doDivideApi = (data) => {
  return cwslapi({
    url: "/store/doDivide",
    method: "post",
    data
  });
};




// 发送到游戏 —— 仓库管理
export const doSendGameApi = (data) => {
  return cwslapi({
    url: "/store/doSendGame",
    method: "post",
    data
  });
};



// 分解道具 —— 仓库管理
export const doRecoverApi = (data) => {
  return cwslapi({
    url: "/store/doRecover",
    method: "post",
    data
  });
};